import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('zn_token'));
  const [loading, setLoading] = useState(true);

  const authHeaders = useCallback(() => {
    return token ? { authorization: `Bearer ${token}` } : {};
  }, [token]);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { authorization: `Bearer ${token}` } })
        .then(res => { setUser(res.data); setLoading(false); })
        .catch(() => { localStorage.removeItem('zn_token'); setToken(null); setUser(null); setLoading(false); });
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (loginVal, password) => {
    const res = await axios.post(`${API}/auth/login`, { login: loginVal, password });
    localStorage.setItem('zn_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const register = async (nick, email, phone, password, referral_code = null) => {
    const res = await axios.post(`${API}/auth/register`, { nick, email: email || null, phone: phone || null, password, referral_code: referral_code || null });
    localStorage.setItem('zn_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('zn_token');
    setToken(null);
    setUser(null);
  };

  const refreshUser = async () => {
    if (token) {
      try {
        const res = await axios.get(`${API}/auth/me`, { headers: { authorization: `Bearer ${token}` } });
        setUser(res.data);
      } catch {}
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, authHeaders, refreshUser, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { API };
